import React from 'react';

const context = React.createContext({
  guest: false
});

export const { Provider, Consumer } = context;
